import { Box } from '@mui/material';
import { useContext } from 'react';
import Joyride from 'react-joyride';
import { ToolContext } from '../../../../core/context/ToolContext';
import { useHistory } from 'react-router-dom';
import { rqx } from '../../../../core/request/API';
import { env } from '../../../../core/Env';
const STATUS = {
  FINISHED: 'finished',
  SKIPPED: 'skipped',
};
const PznlTour = () => {
    const { career_state,tool_state } = useContext(ToolContext)
    const { pznlTour, featureTour } = career_state
    const history = useHistory()

    const handleJoyride = async (event) => {
    const { action, status, type } = event;

    const finished =
            (action === 'reset' && status === STATUS.FINISHED) ||
            (action === 'reset' && status === 'finished') ||
            type === 'tour:end';

            if (finished) {
                const data = await rqx.post(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/create`,
                          {
                            user_id: parseInt(tool_state.userId.data),
                            tool_id: parseInt(process.env.REACT_APP_TID_BIZ),
                            feature_name: 'careerBizTour',
                            personalization: [{ sf_name: 'careerBizTour', status: 1 }]
                          })
                          if (data.msg === 'success') {
                            featureTour.set([{
                                  active: 1,
                                  created_by: parseInt(tool_state.userId.data),
                                  feature_name: "careerBizTour",
                                  personalization: "[{\"status\": 1, \"sf_name\": \"CareerBizTour\"}]",
                                  tool_id: parseInt(process.env.REACT_APP_TID_BIZ),
                              }])
                              history.push('/biz/careers/add');
                          }
            }
    };

    const steps = [
        {
            target: '.dashboard',
            title: <Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box fontWeight={100}>Dashboard</Box>
                         <Box fontSize={14} fontWeight={400}>1/8</Box>
                    </Box>,
            content: <Box fontSize={16} fontWeight={400} > Click <strong>Dashboard</strong>  monitor your summary of all recruitment activities.</Box>,
            disableBeacon: true,
            placement: "right",
        },

        {
            target: '.careers',
            title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Career Post</Box>
                         <Box fontSize={14} fontWeight={400}>2/8</Box>
                    </Box>,
            content:<Box fontSize={16} fontWeight={400} > Click <strong>Career Post</strong>  create job posters and share actively to reach the right candidates.</Box>, 
            disableBeacon: true,
            placement: "right"
        },

        {
            target: '.applicants',
             title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Aplicants</Box>
                         <Box fontSize={14} fontWeight={400}>3/8</Box>
                    </Box>,
            content:<Box fontSize={16} fontWeight={400} >View Click <strong> Applicant List</strong>   monitor applicants and update their progress through the recruitment process. applicant list.</Box>,
            disableBeacon: true,
            placement: "right"
        },

        {
            target: '.toolCategories',
             title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Tool Categories</Box>
                         <Box fontSize={14} fontWeight={400}>4/8</Box>
                    </Box>,
            content: 'This is my awesome feature!',
            disableBeacon: true,
            placement: "right"
        },
        {
            target: '.personal',
            title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Personal</Box>
                         <Box fontSize={14} fontWeight={400}>5/8</Box>
                    </Box>,
            content: 'Switch to Personal to enjoy its benefits to grow your career. Experience seamless switching between Career to Your Personal Acccount',
            disableBeacon: true,
            placement: "bottom"
        },

        {
            target: '.business',
              title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Business</Box>
                         <Box fontSize={14} fontWeight={400}>6/8</Box>
                    </Box>,
            content: 'Switch to Business to enjoy its benefits to grow your business.',
            disableBeacon: true,
            placement: "bottom"
        },

        {
            target: '.myTools',
             title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>My Tools</Box>
                         <Box fontSize={14} fontWeight={400}>7/8</Box>
                    </Box>,
            content: 'Switch to all Business tools that you availed and will be availed.',
            disableBeacon: true,
            placement: "bottom"
        },

        {
            target: '.notifications',
             title:<Box display='flex' justifyContent='space-between'  color='#bdb9b9ff'>
                        <Box>Notification</Box>
                         <Box fontSize={14} fontWeight={400}>8/8</Box>
                    </Box>,
            content: 'Notification for updates and events.',
            disableBeacon: true,
            placement: "bottom"
        },

    ];

    const Tourstyle = () => {      
        const tourcss = {
            options: {
                zIndex: 1202,
                borderRadius: '15px',
                width: '380px',
            },

             spotlight: {
                borderRadius: '4px',
                padding: '20px',
                width: '200px',
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                border: '2px solid white',
        },
        
            buttonClose: {
                display: 'none',
            },

            buttonNext: {
                fontFamily: "Inter",
                fontWeight: 500,
                backgroundColor: "#03A36E",
                padding: "8px",
                fontSize: "12px !important",
                borderRadius: "15px",
                color: "#fff",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px'
                
            },

            buttonSkip: {
                fontFamily: "Inter",
                fontWeight: 500,
                padding: "8px",
                fontSize: "12px !important",
                color: "#A3A3A3",
                cursor: "pointer",
                textAlign: "center",
                width: "80px",
                height: '33px',
                left: 0,
                marginRight: '2px',
                float: 'right'
            },

            tooltip: {
                minHeight: '140px',
                height: '100%',
                borderRadius: '15px',
            },
            
            tooltipFooter: {
                marginTop: 0,
                padding: '0px 16px 0px 16px',
                minHeight: '40px',
            },
            tooltipContent: {
                height: '100%',
                padding: '10px'
                
            },
            overlay: {
                height: '100%'
            },
        }
        return tourcss
    }

    return (
        <Box>
            <Joyride 
                steps={steps} styles={Tourstyle()} 
                run={pznlTour.data} 
                showSkipButton 
                continuous 
                hideBackButton  
                locale={{ skip: 'Close', last: 'Got it' }} 
                callback={handleJoyride}          
            />
        </Box>
    )
}

export default PznlTour;


